module.exports = "/static/assets/6a01561dd5ab6bb86d5e1b1a5d0a2407.png";